const doc = [({"en":({"js":({"organizations":({"select":({"choose_organization":"Choose organization"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;